<script setup lang="ts">
interface Props {
  button?: boolean
}

withDefaults(defineProps<Props>(), {
  button: false,
})
</script>

<template>
  <skeletor class="chip" :class="button" />
</template>

<style scoped lang="scss">
.chip {
  min-height: 24px;
  max-width: 80px;
  border-radius: 30px;

  &.button {
    height: 28px;
    width: 100px;
  }
}
</style>
